var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "municipalInfoDetail", "data-role": "page" } },
    [
      _c(
        "div",
        {
          staticClass: "municipalInfoDetail-content",
          attrs: { "data-position": "fixed" }
        },
        [
          !_vm.closeOffline && _vm.isOffline
            ? _c("div", { staticClass: "v3offline" }, [
                _c("i", { staticClass: "icon-exclamation-mark-circle" }),
                _vm._v(" "),
                _c("p", [_vm._v("未連接至網路")]),
                _vm._v(" "),
                _c("div", { on: { click: _vm.closeOfflineHandle } }, [
                  _c("i", { staticClass: "icon-close" })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.detailData.Id
            ? _c("div", { staticClass: "detailWrap" }, [
                _c("div", { staticClass: "detail-h" }, [
                  _c("h3", { class: { LargSize: _vm.fz_larg } }, [
                    _vm._v(_vm._s(_vm.detailData.Title))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "article_date",
                      class: { LargSize: _vm.fz_larg }
                    },
                    [
                      _vm.detailData.StartAt
                        ? [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.filterDate(
                                    _vm.detailData.StartAt,
                                    _vm.detailType
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.detailData.CreateAt
                        ? [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.filterDate(
                                    _vm.detailData.CreateAt,
                                    _vm.detailType
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-c" }, [
                  _c(
                    "div",
                    {
                      staticClass: "txtContent",
                      class: { LargSize: _vm.fz_larg }
                    },
                    [
                      _vm.detailType === "1" && _vm.detailData.ResourceAgency
                        ? _c("p", [
                            _vm._v(
                              "發佈單位: " +
                                _vm._s(_vm.detailData.ResourceAgency)
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.detailType === "2"
                        ? _c("div", [
                            _vm.detailData.Date
                              ? _c("p", [
                                  _vm._v(
                                    "活動日期: " +
                                      _vm._s(
                                        _vm.filterDate(
                                          _vm.detailData.Date,
                                          _vm.detailType
                                        )
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.DueDate
                              ? _c("p", [
                                  _vm._v(
                                    "活動迄日: " +
                                      _vm._s(
                                        _vm.filterDate(
                                          _vm.detailData.DueDate,
                                          _vm.detailType
                                        )
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.ActivitiesClass
                              ? _c("p", [
                                  _vm._v(
                                    "類別: " +
                                      _vm._s(_vm.detailData.ActivitiesClass)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.ResourceAgency
                              ? _c("p", [
                                  _vm._v(
                                    "來源機關: " +
                                      _vm._s(_vm.detailData.ResourceAgency)
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.detailType === "2"
                        ? _c("p", [_vm._v("內容: ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.contentTransform(_vm.detailData.Content)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm.detailType === "2"
                        ? _c("div", [
                            _vm.detailData.IsNeedSignUp
                              ? _c("p", [
                                  _vm._v(
                                    "是否報名: " +
                                      _vm._s(_vm.detailData.IsNeedSignUp)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.IsNeedPay
                              ? _c("p", [
                                  _vm._v(
                                    "是否付費: " +
                                      _vm._s(_vm.detailData.IsNeedPay)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.Fee
                              ? _c("p", [
                                  _vm._v("費用: " + _vm._s(_vm.detailData.Fee))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.Location
                              ? _c("p", [
                                  _vm._v(
                                    "活動場地: " +
                                      _vm._s(_vm.detailData.Location)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.LocationPhone
                              ? _c("p", [
                                  _vm._v(
                                    "場地電話: " +
                                      _vm._s(_vm.detailData.locationPhone)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.LocationAddress
                              ? _c("p", [
                                  _vm._v(
                                    "活動地址: " +
                                      _vm._s(_vm.detailData.LocationAddress)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.Traffic
                              ? _c("p", [
                                  _vm._v("交通說明: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.contentTransform(
                                          _vm.detailData.Traffic
                                        )
                                      )
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.ContactPerson
                              ? _c("p", { staticClass: "people" }, [
                                  _vm._v(
                                    "聯絡人: " +
                                      _vm._s(_vm.detailData.ContactPerson)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.ContactPhone
                              ? _c("p", [
                                  _vm._v(
                                    "聯絡電話: " +
                                      _vm._s(_vm.detailData.ContactPhone)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.ContactEmail
                              ? _c("p", [
                                  _vm._v(
                                    "電子信箱: " +
                                      _vm._s(_vm.detailData.ContactEmail)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detailData.isAboutUrl
                              ? _c("p", [
                                  _vm._v("活動網址: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.contentTransform(
                                          _vm.detailData.AboutUrl
                                        )
                                      )
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ])
            : _c("div", { staticClass: "loading-wrap" }, [
                _c("p", { staticClass: "loading-rotate" })
              ])
        ]
      ),
      _vm._v(" "),
      _vm.Authority && _vm.detailData.Id
        ? _c(
            "div",
            {
              staticClass: "qk-functionBar active",
              attrs: { id: "v3functionBar" }
            },
            [
              _c("div", { class: ["qk-functionBar-wrap-col4"] }, [
                _c(
                  "div",
                  {
                    staticClass: "fontsize-option",
                    class: { active: _vm.fz_larg },
                    on: { click: _vm.ChangeSize }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "share-option", on: { click: _vm.Share } },
                  [_vm._m(1)]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.v3Toast.show,
              expression: "v3Toast.show"
            }
          ],
          staticClass: "v3Toast"
        },
        [_vm._v(_vm._s(_vm.v3Toast.text))]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "icon-font-size" }),
      _vm._v("大小")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "icon-export" }), _vm._v("分享")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1cde774", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1cde774","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/newMunicipal/municipalInfoDetail.vue
// module id = null
// module chunks = 